import React from 'react'
import {BlockMapForValue} from '../atoms/blockList'
import {BlockType, BlockValue} from './types'
import {TitleBlock} from './titleBlock'
import {ImageBlock} from './imageBlock'
import {EmbedBlock} from './embedBlock'
import {RichTextBlockExampleBlock} from './richTextBlockExample'
import {LinkListBlock} from './linkListBlock'
import {FaqListBlock} from './faqListBlock'
import {CodeSnippetBlock} from './codeSnippetBlock'
import {AccordionBlock} from './accordionBlock'
import {GenericBlock} from './genericBlock'
import {TableBlock} from './tableBlock'

import Header from '@rsuite/icons/legacy/Header'
import Code from '@rsuite/icons/legacy/Code'
import FileText from '@rsuite/icons/legacy/FileText'
import Image from '@rsuite/icons/legacy/Image'
import ThList from '@rsuite/icons/legacy/ThList'
import Question from '@rsuite/icons/legacy/Question'
import Frame from '@rsuite/icons/legacy/Frame'
import Bars from '@rsuite/icons/legacy/Bars'
import Filter from '@rsuite/icons/legacy/Filter'
import NewspaperO from '@rsuite/icons/legacy/NewspaperO'
import Rocket from '@rsuite/icons/legacy/Rocket'
import Th from '@rsuite/icons/legacy/Th'
import CodeFork from '@rsuite/icons/legacy/CodeFork'
import Table from '@rsuite/icons/legacy/Table'
import Space from '@rsuite/icons/legacy/ArrowsV'
import DataDecrease from '@rsuite/icons/legacy/DataDecrease'
import QuoteLeft from '@rsuite/icons/legacy/QuoteLeft'
import ArrowsH from '@rsuite/icons/legacy/ArrowsH'
import Hashtag from '@rsuite/icons/legacy/Hashtag'
import ThreeColumnsIcon from '@rsuite/icons/ThreeColumns'
import Retweet from '@rsuite/icons/legacy/Retweet'

export const BlockMap: BlockMapForValue<BlockValue> = {
  [BlockType.Title]: {
    field: (props) => <TitleBlock {...props} />,
    label: 'Title',
    icon: <Header />,
  },

  [BlockType.CodeSnippet]: {
    field: (props) => <CodeSnippetBlock {...props} />,
    label: 'iFrame',
    icon: <Code />,
  },

  [BlockType.RichText]: {
    field: (props) => <RichTextBlockExampleBlock {...props} />,
    label: 'Rich Text',
    icon: <FileText />,
  },

  [BlockType.Image]: {
    field: (props) => <ImageBlock {...props} />,
    label: 'Image',
    icon: <Image />,
  },

  [BlockType.LinkList]: {
    field: (props) => <LinkListBlock {...props} />,
    label: 'Link List',
    icon: <ThList />,
  },

  [BlockType.FaqList]: {
    field: (props) => <FaqListBlock {...props} />,
    label: 'Faq List',
    icon: <Question />,
  },
  [BlockType.FaqListGroups]: {
    field: (props) => <GenericBlock {...props} />,
    label: 'FAQ Liste',
    icon: <Question />,
  },

  [BlockType.Embed]: {
    field: (props) => <EmbedBlock {...props} />,
    label: 'Embed',
    icon: <Frame />,
  },

  [BlockType.Accordion]: {
    field: (props) => <AccordionBlock {...props} />,
    label: 'Accordion',
    labelI18n: {
      de: 'Akkordeon',
      en: 'Accordion',
    },
    icon: <Bars />,
  },

  [BlockType.TeaserSection]: {
    field: (props) => <GenericBlock {...props} />,
    label: 'Teaser Grid Layout',
    icon: <Th />,
  },
  [BlockType.FilterViews]: {
    field: (props) => <GenericBlock {...props} />,
    label: 'Filter Views',
    icon: <Filter />,
  },
  [BlockType.News]: {
    field: (props) => <GenericBlock {...props} />,
    label: 'News',
    icon: <NewspaperO />,
  },
  [BlockType.Hero]: {
    field: (props) => <GenericBlock {...props} />,
    label: 'Hero Gallery',
    icon: <Rocket />,
  },
  [BlockType.NewsGrid]: {
    field: (props) => <GenericBlock {...props} />,
    label: 'News Grid Layout',
    icon: <Th />,
  },
  [BlockType.TeaserSlider]: {
    field: (props) => <GenericBlock {...props} />,
    label: 'Teaser Slider',
    icon: <ArrowsH />,
  },
  [BlockType.Custom]: {
    field: (props) => <GenericBlock {...props} />,
    label: 'Custom',
    icon: <CodeFork />,
  },
  [BlockType.Anchor]: {
    field: (props) => <GenericBlock {...props} />,
    label: 'Anchor',
    icon: <Hashtag />,
  },
  [BlockType.Table]: {
    field: (props) => <TableBlock {...props} />,
    label: 'Table',
    icon: <Table />,
  },
  [BlockType.CtaButton]: {
    field: (props) => <GenericBlock {...props} />,
    label: 'CTA Button',
    icon: <DataDecrease />,
  },
  [BlockType.Spacer]: {
    field: (props) => <GenericBlock {...props} />,
    label: 'Spacer',
    icon: <Space />,
  },
  [BlockType.CustomQuote]: {
    field: (props) => <GenericBlock {...props} />,
    label: 'Quote',
    icon: <QuoteLeft />,
  },
  [BlockType.ImageGrid]: {
    field: (props) => <GenericBlock {...props} />,
    label: 'Image Grid',
    icon: <ThreeColumnsIcon />,
  },
  [BlockType.Flipcards]: {
    field: (props) => <GenericBlock {...props} />,
    label: 'Timeline',
    labelI18n: {
      de: 'Timeline',
      en: 'Timeline',
    },
    icon: <Retweet />,
  },
}
